<!--<div fxFlexFill fxLayout="column" fxLayoutAlign="center stretch" class="participant-container">-->
  <audio #participantAudio *ngIf="audioEnabled" autoplay [muted]="audioMuted"></audio>
  <video #participantVideo *ngIf="videoEnabled && !audioOnly" fxFlex [style]="customStyle" autoplay [muted]="videoMuted" playsinline (click)="refresh()"></video>
<!--</div>-->
<!--<div #participantContainer>-->

<!--</div>-->
